import { Box, Flex, Text, Heading, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import { route } from 'nextjs-routes';

import useApiQuery from 'lib/api/useApiQuery';
import { AddressHighlightProvider } from 'lib/contexts/addressHighlight';
import { TX } from 'stubs/tx';
import LinkInternal from 'ui/shared/links/LinkInternal';

import LatestTxsItem from './LatestTxsItem';
import LatestTxsItemMobile from './LatestTxsItemMobile';

const LatestTransactions = () => {
  const borderColor = useColorModeValue('#e9ecef', 'gray.700');
  const bgColor = useColorModeValue('#f8f9fa', '#16161B');
  const hoverBgColor = useColorModeValue('#e9ecef', '#16161B');
  // Always show 6 transactions like Etherscan
  const txsCount = 6;
  const { data, isPlaceholderData, isError } = useApiQuery('homepage_txs', {
    queryOptions: {
      placeholderData: Array(txsCount).fill(TX),
      // Keep homepage tx list fresh even without socket updates.
      refetchInterval: 8000,
      refetchOnWindowFocus: true,
    },
  });

  if (isError) {
    return <Text mt={ 4 }>No data. Please reload the page.</Text>;
  }

  if (data) {
    const txsUrl = route({ pathname: '/txs' });
    return (
      <Box
        bg="card_bg"
        borderRadius="lg"
        border="1px solid"
        borderColor="card_border"
        boxShadow="0 0.5rem 1.2rem rgba(189,197,209,.2)"
        overflow="hidden"
      >
        { /* Card Header - Etherscan exact style */ }
        <Flex
          justifyContent="space-between"
          alignItems="center"
          py={ 2 }
          px={ 5 }
          borderBottom="1px solid"
          borderColor="card_border"
        >
          <Heading as="h4" fontSize="16px" color="text_primary" fontWeight={ 500 }>Latest Transactions</Heading>
        </Flex>

        { /* Mobile view - padding so content has space inside card */ }
        {/* <Box display={{ base: 'block', lg: 'none' }} px={{ base: 4, lg: 0 }} py={{ base: 3, lg: 0 }}>
          { data.slice(0, txsCount).map(((tx, index) => (
            <LatestTxsItemMobile
              key={ tx.hash + (isPlaceholderData ? index : '') }
              tx={ tx }
              isLoading={ isPlaceholderData }
            />
          ))) }
        </Box> */}

        { /* Desktop view */ }
        <AddressHighlightProvider>
          <Box >
            { data.slice(0, txsCount).map(((tx, index) => (
              <LatestTxsItem
                key={ tx.hash + (isPlaceholderData ? index : '') }
                tx={ tx }
                isLoading={ isPlaceholderData }
              />
            ))) }
          </Box>
        </AddressHighlightProvider>

        { /* View All Button - Etherscan exact style */ }
        <Flex
          as={ LinkInternal }
          href={ txsUrl }
          className="LatestTxnViewAll"
          justifyContent="center"
          alignItems="center"
          gap={ 2 }
          py={ 4 }
          bg={bgColor}
          borderTop="1px solid"
          borderColor={borderColor}
          _hover={{ bg: hoverBgColor }}
          transition="background 0.2s"
          fontSize="13px"
          fontWeight={ 500 }
          textTransform="uppercase"
          letterSpacing="0.5px"
          color="text_primary"
          textDecoration="none"
        >
          VIEW ALL TRANSACTIONS
          <Box as="span" ml={ 1 }>→</Box>
        </Flex>
      </Box>
    );
  }

  return null;
};

export default LatestTransactions;
